<ridango-block-full-width>
    <rwidget-alert></rwidget-alert>

    <div class="bold margin-bottom-20 mobile-center">
        {{ 'CARD_STATUS_CHECK_STATUS' | translate }}
    </div>

    <div class="travel-card-tickets flex-column margin-bottom-20 flex">
        <mat-form-field class="w-full" appearance="outline">
            <mat-label>{{ 'PH_INSERT_TRAVELCARD_NUMBER' | translate }}</mat-label>
            <input
                #cardInput
                [formControl]="cardNumberForm.controls.card_number"
                [required]="required"
                matInput
                type="text" />
            <mat-error *ngIf="cardNumberForm.controls.card_number.hasError('required')">
                {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
            </mat-error>

            <mat-error *ngIf="cardNumberForm.controls.card_number.hasError('pattern')">
                {{ 'FIELD_VALIDATION_CARD_NUMBER_INVALID_FORMAT' | translate }}
            </mat-error>

            <mat-error *ngIf="cardNumberForm.controls.card_number.hasError('minlength')">
                {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
            </mat-error>

            <mat-error *ngIf="cardNumberForm.controls.card_number.hasError('maxlength')">
                {{ 'LOCAL_INPUT_VALIDATION_MAX_LENGTH' | translate }}
            </mat-error>
            <mat-error *ngIf="cardNumberForm.controls.card_number.hasError('personalCodeNotAllowed')">
                {{ 'LOCAL_INPUT_VALIDATION_PERSONAL_CODE' | translate }}
            </mat-error>
        </mat-form-field>

        <ridango-terms-and-conditions-block
            [termsAgreed]="termsAgreed"
            [termsUrl]="termsUrl"
            [terms]="terms"
            [locale]="locale"
            (onAgreementChange)="agreeTerms($event)">
        </ridango-terms-and-conditions-block>

        <div class="check-status__button">
            <button
                class="btn btn--maximal btn--primary"
                [disabled]="(termsAgreed$ | async) === false"
                (click)="submitCardNumber()">
                {{ 'LOCAL_BTN_CHECK' | translate }}
            </button>
        </div>
    </div>

    <!--CARD BALANCE INFO-->
    <div class="card-detail-view-area margin-bottom-60" *ngIf="(cardBalance$ | async)?.card_id">
        <p class="page-title">
            {{ 'TRAVEL_CARD_MY_TICKETS_TITLE' | translate }}
        </p>
        <div class="block-card-detail card-number">
            <span class="title">
                {{ 'RELATED_CARD_DETAIL_CARD_NUMBER' | translate }}
            </span>
            <span>{{ cardNumber$ | async }}</span>
        </div>

        <div class="block-card-detail card-balance">
            <span class="title">
                {{ 'RELATED_CARD_DETAIL_CARD_BALANCE' | translate }}
            </span>
            <span>
                {{ (cardBalance$ | async).balance | centsToMajorUnit | moneyFormat }}
                {{ (cardBalance$ | async)?.currency }}
            </span>
        </div>
    </div>

    <!-- SWITCH -->
    <div class="tabs margin-bottom-20" *ngIf="(cardBalance$ | async)?.card_id">
        <a class="link" [ngClass]="{ active: showTab === 'activeTickets' }" (click)="switchTab('activeTickets')">{{
            'CARD_STATUS_TITLE_ACTIVE_TICKETS' | translate
        }}</a>
        <!--<a class="link last"
			[ngClass]="{ active: showTab === 'purchaseHistory' }"
			(click)="switchTab('purchaseHistory')">{{'CARD_STATUS_TITLE_PURCHASE_HISTORY' | translate}}</a>-->
    </div>

    <!-- NO ACTIVE TICKETS AT ALL  -->
    <div
        class="empty-card-detail-view-area-ticket"
        *ngIf="showTab === 'activeTickets' && (cardBalance$ | async)?.card_id && (cardTickets$ | async)?.length === 0">
        <p class="empty-card-detail-view-area-ticket__description">
            {{ 'TRAVELCARD_NO_TICKETS_DESCRIPTION' | translate }}
        </p>
        <a
            class="btn btn--primary flex-inline flex-align-center link--no-line link--no-line-hover"
            [routerLink]="(env.ENABLE_PURCHASE_V2 ? '/purchase-v2' : '/purchase/ticket') | localize"
            >{{ 'TRAVELCARD_BUY_TICKET_BUTTON' | translate }}</a
        >
    </div>

    <!-- ACTIVE TICKETS -->
    <div class="card-detail-view-area-ticket" *ngIf="showTab === 'activeTickets' && (cardTickets$ | async)?.length > 0">
        <rwidget-account-tickets-list [tickets]="cardTickets$ | async" [locale]="locale">
        </rwidget-account-tickets-list>
    </div>

    <!-- PURCHASE HISTORY -->
    <!--<rwidget-purchase-history *ngIf="showTab === 'purchaseHistory'">
	 </rwidget-purchase-history>-->
</ridango-block-full-width>
